// "gitlab.helm.chart_file_present" → "Helm Chart File Present"
export function formatFactKey(key: string): string {
  return key
    .replace(/^[^.]+\./, '')
    .replace(/\./g, ' ')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
}
